import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Loader from "./components/Loader/Loader";
import authService from "./services/auth.service";
import "./App.scss";

const DashboardRedirect: React.FC = () => {
  const [target, setTarget] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      const preferred = authService.getUser()?.principalType;
      const order: Array<"user" | "admin"> =
        preferred === "admin" ? ["admin", "user"] : ["user", "admin"];

      for (const type of order) {
        if (cancelled) return;
        try {
          const response =
            type === "user"
              ? await authService.validateUser()
              : await authService.validateAdmin();

          if (cancelled) return;
          if (response.valid) {
            setTarget(`/${type}/dashboard`);
            return;
          }
        } catch {
          continue;
        }
      }

      if (!cancelled) setTarget("/login");
    };

    void resolve();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!target) {
    return <Loader message="Loading dashboard..." />;
  }

  return <Navigate to={target} replace />;
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<DashboardRedirect />} />
          <Route path="/user" element={<Navigate to="/user/dashboard" replace />} />
          <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/user/dashboard" element={<Dashboard mode="user" />} />
          <Route path="/admin/dashboard" element={<Dashboard mode="admin" />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
